module.exports = __webpack_public_path__ + "static/media/emoji-high-score-2x.4d4fe39e.png";